import React, { useState } from 'react';
import { FormCard, FormTextInput, StandaloneFormPage } from 'tabler-react';
import { useHistory, Redirect } from 'react-router-dom';
import { auth } from '../services/firebase';

function ForgotPasswordPage() {
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState(null);

  const onSubmit = (e) => {
    e.preventDefault();

    setErrors(null);

    auth().sendPasswordResetEmail(
      email
    ).then(() => {
      alert('Enviamos um email com as instruções para configurar uma nova senha');

      history.push('/signin');
    }).catch(err => {
      console.error(err);
      setErrors({ email: 'Email não encontrado'});
    });
  };

  return auth().currentUser ?
    (
      <Redirect to={{ pathname: "/" }} />
    ) : (
      <StandaloneFormPage imageURL={"./assets/images/logo.png"}>
        <FormCard
          buttonText="Solicitar uma nova senha"
          title="Portal dos Corretores"
          onSubmit={onSubmit}
        >
          <FormTextInput
            name="email"
            label="Email"
            onChange={(e) => {setEmail(e.target.value)}}
            value={email}
            error={errors && errors.email}
          />
        </FormCard>
      </StandaloneFormPage>
    )
}

export default ForgotPasswordPage;